import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import headerImage from "../../assets/appheader.png";
import styles from "./index.module.css";

export const About = () => {
  return (
    <Container className={styles.container}>
      <img src={headerImage} alt="ItsyBitseList" className={styles.headerImage} />
      <h1 className={styles.title}>About ItsyBitseList</h1>

      <div className={styles.content}>
        <p>
          Every birthday and Christmas, the same thing happened: someone in the
          family would ask "what do you want?" and the answer would get lost in a
          group chat, or two people would buy the same thing.
        </p>
        <p>
          ItsyBitseList fixes that. You create a wishlist, share a link, and
          people can promise items without you ever seeing who claimed what. The
          gift-giver gets a secret key so only they can undo their promise. No
          accounts, no sign-up friction.
        </p>

        <h2 className={styles.subtitle}>How it started</h2>
        <p>
          This was my first project built with AI assistance — GitHub Copilot
          for code completion and ChatGPT for problem-solving. No agents, no
          generated architectures — just conversational back-and-forth and
          autocomplete. Everything from the clean architecture layout to the
          Azure deployment was decided and wired up by hand.
        </p>

        <h2 className={styles.subtitle}>How it works</h2>
        <ul className={styles.list}>
          <li>Create a wishlist with a name and optional description</li>
          <li>Add items with links, images, and a priority rating</li>
          <li>Share your wishlist via a public link</li>
          <li>Gift-givers claim items anonymously with a secret key</li>
          <li>You see what's promised, but never by whom</li>
        </ul>
      </div>

      <div className={styles.footer}>
        <Link to="/" className={styles.link}>Back to Home</Link>
      </div>
    </Container>
  );
};
